import { Flex } from "@chakra-ui/react";
import { StyledAdminLayoutParent } from "@root/components/adminDashboard/style";
import { HeadingText } from "@root/components/common/text/HeadingText";
import { NormalText } from "@root/components/adminDashboard/style";
import { CustomLoader } from "@root/components/common/loaders/CustomLoader";
import { TabsLayout } from "@root/components/tabs-layout";
import { useAdminBranding } from "@root/hooks/useAdminBranding";
import { useTranslation } from "react-i18next";
import { LogoImagesTab } from "./tabs/LogoImagesTab";
import { ColorsTab } from "./tabs/ColorsTab";
import { TypographyTab } from "./tabs/TypographyTab";
import { CustomDomainTab } from "./tabs/CustomDomainTab";
import { EmailTemplatesTab } from "./tabs/EmailTemplatesTab";

export const AdminBrandingScreen = () => {
  const { t } = useTranslation("common");
  const {
    loading,
    config,
    activeTab,
    setActiveTab,
    tabs,
    handleUploadLogo,
    handleDeleteLogo,
    savingLogo,
    handleUpdateColors,
    savingColors,
    handleUpdateTypography,
    savingTypography,
    handleAddDomain,
    handleVerifyDomain,
    handleDeleteDomain,
    savingDomain,
    handleUpdateEmailBranding,
    savingEmail,
  } = useAdminBranding();

  return (
    <StyledAdminLayoutParent>
      <Flex flexDir="column" gap="16px" p="24px">
        <Flex flexDirection="column">
          <HeadingText
            text={t("admin.branding.title")}
            fontWeight="700"
            fontSize="26px"
          />
          <NormalText text={t("admin.branding.subtitle")} />
        </Flex>

        {loading ? (
          <CustomLoader />
        ) : (
          <TabsLayout
            tabs={tabs}
            tabIndex={activeTab}
            onTabChange={setActiveTab}
          >
            <LogoImagesTab
              config={config}
              onUpload={handleUploadLogo}
              onDelete={handleDeleteLogo}
              saving={savingLogo}
            />
            <ColorsTab
              config={config}
              onSave={handleUpdateColors}
              saving={savingColors}
            />
            <TypographyTab
              config={config}
              onSave={handleUpdateTypography}
              saving={savingTypography}
            />
            <CustomDomainTab
              config={config}
              onAddDomain={handleAddDomain}
              onVerifyDomain={handleVerifyDomain}
              onDeleteDomain={handleDeleteDomain}
              saving={savingDomain}
            />
            <EmailTemplatesTab
              config={config}
              onSave={handleUpdateEmailBranding}
              saving={savingEmail}
            />
          </TabsLayout>
        )}
      </Flex>
    </StyledAdminLayoutParent>
  );
};
